import ChatAppContainer from "../../Componant/Chat/ChatApp";

const ChatApp = () => {
  return (
    <div className="page-body">
      <ChatAppContainer />
    </div>
  );
};

export default ChatApp;
